import React from 'react';
import { Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import { errorService } from '../../../graphql/utils/utils';
import { graphql, compose, withApollo } from 'react-apollo';
import * as Icons from '@ant-design/icons';

import Loading from '../../common/Loading';

import FormEditarOrganismo from './FormEditarOrganismos';

import updateOrganismoPorId from '../../../graphql/mutations/organismos/updateOrganismoPorId.graphql';
import getOrganismoPorId from '../../../graphql/querys/organismos/getOrganismoPorId.graphql';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@compose(
  graphql(updateOrganismoPorId, {
    name: 'updateOrganismoPorId',
  })
)
class EditarOrganismo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      organismo: {},
      loading: true,
    };

    this.props.client
      .query({
        query: getOrganismoPorId,
        variables: { _id: this.props.match.params.id },
      })
      .then(res => {
        const organismo = res.data.getOrganismoPorId;
        this.setState({
          loading: false,
          organismo: organismo,
        });
      })
      .catch(err => {
        console.log('Error en la creacion');
        console.log(err);
        errorService(err, {
          _id: this.props.match.params.id,
        });
        Modal.error({
          title: 'Error en la creacion del componente grafico',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });

    this.onCancel = this.onCancel.bind(this);
  }

  guardarOrganismo = organismo => {
    // console.log('el organismo es...');
    // console.log(organismo);
    this.setState(
      {
        organismo: {
          ...this.state.organismo,
          ...organismo,
        },
      },
      function() {
        let nuevoOrganismo = this.state.organismo;

        // console.log("ORGANISMO:");
        // console.log(nuevoOrganismo);
        delete nuevoOrganismo.responsable;
        delete nuevoOrganismo.talonarios;
        delete nuevoOrganismo.__typename;
        delete nuevoOrganismo._id;

        this.props
          .updateOrganismoPorId({
            variables: {
              _id: this.props.match.params.id,
              nuevoOrganismo: nuevoOrganismo,
            },
          })
          // eslint-disable-next-line no-unused-vars
          .then(res => {
            notification.success({
              message: 'Actualizacion Correcta',
              description: 'Se ha registrado los nuevos datos del organismo',
            });

            this.props.history.push('/admin/organismos');
          })
          .catch(err => {
            console.log('Error en la actualizacion del organismo');
            console.log(err);
            errorService(err, {
              _id: this.props.match.params.id,
              nuevoOrganismo: nuevoOrganismo,
            });
            Modal.error({
              title: 'Error en la actualizacion de los datos del organismo',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      }
    );
  };

  onCancel() {
    this.setState({
      fase: 0,
    });
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Organismo</Breadcrumb.Item>
          <Breadcrumb.Item>Editar</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Editar Organismo
          </h2>
          <br />
          <div style={estiloContent}>
            <FormEditarOrganismo
              className="formularios"
              onSubmit={this.guardarOrganismo}
              onAnterior={() => this.props.history.push('/admin/organismos')}
              datos={this.state.organismo}
              usuario={this.props.usuario}
            />
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(EditarOrganismo);
